var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseCircleOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.25,
    height: 29.25,
    viewBox: "0 0 29.25 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-md-close-circle-outline"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1133",
    d: "M18 6.328a11.667 11.667 0 1 1-8.255 3.417A11.623 11.623 0 0 1 18 6.328m0-2.953A14.625 14.625 0 1 0 32.625 18 14.623 14.623 0 0 0 18 3.375z",
    style: {
      fill: "#fc0e0e"
    },
    transform: "translate(-3.375 -3.375)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1134",
    d: "m25.313 23.266-2.046 2.046L18 20.046l-5.266 5.266-2.046-2.046L15.954 18l-5.266-5.266 2.046-2.046L18 15.954l5.266-5.266 2.046 2.046L20.046 18z",
    style: {
      fill: "#fc0e0e"
    },
    transform: "translate(-3.375 -3.375)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleOutline);
export default __webpack_public_path__ + "static/media/close-circle-outline.6571d2b2aa212abf3f77b0d69107a565.svg";
export { ForwardRef as ReactComponent };